import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import RestrictedArea from "../../core/components/core/RestrictedArea";

import CompanyList from "../components/pdc/companies/List"
import CompanyForm from "../components/pdc/companies/Form"
import CompanyEdit from "../components/pdc/companies/Edit"

import BusinessManagerList from "../components/pdc/businessmanagers/List"
import BusinessManagerForm from "../components/pdc/businessmanagers/Form"
import BusinessManagerEdit from "../components/pdc/businessmanagers/Edit"

import EntityList from "../components/pdc/entities/List"
import EntityForm from "../components/pdc/entities/Form"
import EntityEdit from "../components/pdc/entities/Edit"

import EntityManagerList from "../components/pdc/entitymanagers/List"
import EntityManagerForm from "../components/pdc/entitymanagers/Form"
import EntityManagerEdit from "../components/pdc/entitymanagers/Edit"

import ClientList from "../components/pdc/clients/List"
import ClientForm from "../components/pdc/clients/Form"

import PrincipalList from "../components/pdc/principals/List"
import PrincipalForm from "../components/pdc/principals/Form"

import RoleList from "../components/pdc/roles/List"
import RoleForm from "../components/pdc/roles/Form"

import ProfessionList from "../components/pdc/professions/List"
import ProfessionForm from "../components/pdc/professions/Form"

import ProjectList from "../components/pdc/projects/List"
import ProjectForm from "../components/pdc/projects/Form"
import ProjectEdit from "../components/pdc/projects/Edit"

import ProjectModalityList from "../components/pdc/projectmodalities/List"
import ProjectModalityForm from "../components/pdc/projectmodalities/Form"

import DocumentationCategoryList from "../components/pdc/documentationcategories/List"
import DocumentationCategoryForm from "../components/pdc/documentationcategories/Form"

import DocumentTypeList from "../components/pdc/documenttypes/List"
import DocumentTypeForm from "../components/pdc/documenttypes/Form"

import AnnouncementCategoryList from "../components/pdc/announcementcategories/List"
import AnnouncementCategoryForm from "../components/pdc/announcementcategories/Form"

import DemonstrativeTypeList from "../components/pdc/demonstrativetypes/List"
import DemonstrativeTypeForm from "../components/pdc/demonstrativetypes/Form"

import AdjustTypeList from "../components/pdc/adjusttypes/List"
import AdjustTypeForm from "../components/pdc/adjusttypes/Form"

import DocumentationList from "../components/pdc/documentations/List"
import DocumentationForm from "../components/pdc/documentations/Form"

import ProjectDocumentationList from "../components/pdc/projectdocumentations/List"
import ProjectDocumentationForm from "../components/pdc/projectdocumentations/Form"

import ContractualizationList from "../components/pdc/contractualizations/List"
import ContractualizationForm from "../components/pdc/contractualizations/Form"

import FileMonitoringList from "../components/pdc/filemonitorings/List"

import AnnouncementList from "../components/pdc/announcements/List"
import AnnouncementForm from "../components/pdc/announcements/Form"

import DemonstrativeList from "../components/pdc/demonstratives/List"
import DemonstrativeForm from "../components/pdc/demonstratives/Form"

import OrganizationalChartList from "../components/pdc/organizationalcharts/List"
import OrganizationalChartForm from "../components/pdc/organizationalcharts/FormWrapper"

import ProjectManagerList from "../components/pdc/projectmanagers/List"
import ProjectManagerForm from "../components/pdc/projectmanagers/Form"
import ProjectManagerEdit from "../components/pdc/projectmanagers/Edit"

import BiManagerList from "../components/pdc/bimanagers/List"
import BiManagerForm from "../components/pdc/bimanagers/Form"
import BiManagerEdit from "../components/pdc/bimanagers/Edit"

import PhysicFinanceList from "../components/pdc/physicfinances/List"
import PhysicFinanceForm from "../components/pdc/physicfinances/Form"

import BalanceList from "../components/pdc/balances/List"
import BalanceForm from "../components/pdc/balances/Form"

import ReportList from "../components/pdc/reports/List"
import ReportForm from "../components/pdc/reports/Form"

import MedicalScaleList from "../components/pdc/medicalscales/List"
import MedicalScaleForm from "../components/pdc/medicalscales/Form"

import PortalHome from "../components/pdc/portal/home/Home"
import PortalEntity from "../components/pdc/portal/entities/Entity"

import CompetencyBankingHistoryList from "../components/pdc/bankinghistories/CompetenciesList"
import FileBankingHistoryList from "../components/pdc/bankinghistories/FilesList"
import BankingHistoryList from "../components/pdc/bankinghistories/List"
import BankingHistoryForm from "../components/pdc/bankinghistories/Form"

import FileEntityEmployeeList from "../components/pdc/entityemployees/FilesList"
import EntitiesEntityEmployeeList from "../components/pdc/entityemployees/EntitiesList"
import EntityEmployeeList from "../components/pdc/entityemployees/List"
import EntityEmployeeForm from "../components/pdc/entityemployees/Form"

import FileEmployeePaymentList from "../components/pdc/fileemployeepayments/List"
import FileEmployeePaymentForm from "../components/pdc/fileemployeepayments/Form"
import FileEmployeePaymentPaymentsList from "../components/pdc/fileemployeepayments/PaymentList"

import ProcessTypeList from "../components/pdc/processtypes/List"
import ProcessTypeForm from "../components/pdc/processtypes/Form"

import ProcessList from "../components/pdc/processes/List"
import ProcessForm from "../components/pdc/processes/Form"

import EditalDocumentTypeList from "../components/pdc/editaldocumenttypes/List"
import EditalDocumentTypeForm from "../components/pdc/editaldocumenttypes/Form"

import EditalList from "../components/pdc/editals/List"
import EditalForm from "../components/pdc/editals/Form"

import ContractStatusList from "../components/pdc/contractstatuses/List"
import ContractStatusForm from "../components/pdc/contractstatuses/Form"

import ContractTypeList from "../components/pdc/contracttypes/List"
import ContractTypeForm from "../components/pdc/contracttypes/Form"

import SupplierList from "../components/pdc/suppliers/List"
import SupplierForm from "../components/pdc/suppliers/Form"

import ContractList from "../components/pdc/contracts/List"
import ContractForm from "../components/pdc/contracts/Form"

import MovementTypeList from "../components/pdc/movementtypes/List"
import MovementTypeForm from "../components/pdc/movementtypes/Form"

import MovementList from "../components/pdc/movements/List"
import MovementForm from "../components/pdc/movements/Form"

import MedicalScaleTypeList from "../components/pdc/medicalscaletypes/List"
import MedicalScaleTypeForm from "../components/pdc/medicalscaletypes/Form"

import EntitySpecialtyList from "../components/pdc/entityspecialties/List"
import EntitySpecialtyForm from "../components/pdc/entityspecialties/Form"
import RoleNameList from "../components/pdc/rolenames/List"
import RoleNameForm from "../components/pdc/rolenames/Form"
import SectorList from "../components/pdc/sectors/List"
import SectorForm from "../components/pdc/sectors/Form"
import EducationLevelList from "../components/pdc/educationlevels/List"
import EducationLevelForm from "../components/pdc/educationlevels/Form"
import LeadershipPositionList from "../components/pdc/leadershippositions/List"
import LeadershipPositionForm from "../components/pdc/leadershippositions/Form"
import CompetencyCategoryList from "../components/pdc/competencycategories/List"
import CompetencyCategoryForm from "../components/pdc/competencycategories/Form"
import TechnicalCompetencyList from "../components/pdc/technicalcompetencies/List"
import TechnicalCompetencyForm from "../components/pdc/technicalcompetencies/Form"
import BehavioralCompetencyList from "../components/pdc/behavioralcompetencies/List"
import BehavioralCompetencyForm from "../components/pdc/behavioralcompetencies/Form"
import RoleClassList from "../components/pdc/roleclasses/List"
import RoleClassForm from "../components/pdc/roleclasses/Form"
import RoleClassificationList from "../components/pdc/roleclassifications/List"
import RoleClassificationForm from "../components/pdc/roleclassifications/Form"
import TrainingList from "../components/pdc/trainings/List"
import TrainingForm from "../components/pdc/trainings/Form"
import SystemAccessList from "../components/pdc/systemaccesses/List"
import SystemAccessForm from "../components/pdc/systemaccesses/Form"
import PositionList from "../components/pdc/positions/List"
import PositionForm from "../components/pdc/positions/Form"

import ProjectDepartmentList from "../components/pdc/projectdepartments/List"
import ProjectDepartmentForm from "../components/pdc/projectdepartments/Form"

import ProjectIndicatorsList from "../components/pdc/projectindicators/List"
import ProjectIndicatorsForm from "../components/pdc/projectindicators/Form"

import FileAccountabilitiesList from "../components/pdc/fileaccountabilities/List.js"
import FileAccountabilitiesForm from "../components/pdc/fileaccountabilities/Form.js"

import AccountingProjectsList from "../components/pdc/accountingprojects/List.js"
import AccountingProjectsForm from "../components/pdc/accountingprojects/Form.js"

import AccountingClientsList from "../components/pdc/accountingclients/List.js"
import AccountingClientsForm from "../components/pdc/accountingclients/Form.js"

import PcontasAccountsPayableList from "../components/pdc/pcontasaccountspayable/List.js"
import PcontasAccountsPayableForm from "../components/pdc/pcontasaccountspayable/Form.js"

import PcontasAccountsRevenueList from "../components/pdc/pcontasaccountsrevenue/List.js"
import PcontasAccountsRevenueForm from "../components/pdc/pcontasaccountsrevenue/Form.js"

import ServiceCharterList from "../components/pdc/servicecharters/List"
import ServiceCharterForm from "../components/pdc/servicecharters/Form"

import BankAccountList from "../components/pdc/bankaccounts/List.js"
import BankAccountForm from "../components/pdc/bankaccounts/Form.js"

import BankForm from "../components/pdc/banks/Form.js"
import BankList from "../components/pdc/banks/List.js"

import BankAgencyForm from "../components/pdc/bankagencies/Form.js"
import BankAgencyList from "../components/pdc/bankagencies/List.js"

import BankAccountTypeForm from "../components/pdc/bankaccounttypes/Form.js"
import BankAccountTypeList from "../components/pdc/bankaccounttypes/List.js"

import LegalTypesList from "../components/pdc/legaltypes/List.js"
import LegalTypesForm from "../components/pdc/legaltypes/Form.js"

import AttachmentList from "../components/pdc/attachmenttypes/List.js"
import AttachmentForm from "../components/pdc/attachmenttypes/Form.js"

import PaymentMethodsList from "../components/pdc/paymentMethods/List.js"
import PaymentMethodsForm from "../components/pdc/paymentMethods/Form.js"

import TaxCategoriesList from "../components/pdc/taxcategories/List.js"
import TaxCategoriesForm from "../components/pdc/taxcategories/Form.js"

import ResourceSourcesClassificationsList from "../components/pdc/resourcesourcesclassifications/List.js"
import ResourceSourcesClassificationsForm from "../components/pdc/resourcesourcesclassifications/Form.js"

import SelectionProcessList from "../components/pdc/selectionprocesses/List"
import SelectionProcessForm from "../components/pdc/selectionprocesses/Form"

import ResourceSourcesList from "../components/pdc/resourcesources/List.js"
import ResourceSourcesForm from "../components/pdc/resourcesources/Form.js"

import PeopleList from "../components/pdc/people/List.js"
import PeopleForm from "../components/pdc/people/Form.js"
import PeopleEdit from "../components/pdc/people/Edit.js"

import ProjectUnitsList from "../components/pdc/projectunits/List.js"
import ProjectUnitsForm from "../components/pdc/projectunits/Form.js"

import FiscalCategoriesList from "../components/pdc/fiscalcategories/List.js"
import FiscalCategoriesForm from "../components/pdc/fiscalcategories/Form.js"

import CourtAuditorsCategoriesList from "../components/pdc/courtauditorscategories/List.js"
import CourtAuditorsCategoriesForm from "../components/pdc/courtauditorscategories/Form.js"

import WorkPlanCategoriesList from "../components/pdc/workplancategories/List.js"
import WorkPlanCategoriesForm from "../components/pdc/workplancategories/Form.js"

import WorkPlanSubCategoriesList from "../components/pdc/workplansubcategories/List.js"
import WorkPlanSubCategoriesForm from "../components/pdc/workplansubcategories/Form.js"

import TaxesList from "../components/pdc/taxes/List.js"
import TaxesForm from "../components/pdc/taxes/Form.js"

import DocumentTypePcontasList from "../components/pdc/documenttypespcontas/List"
import DocumentTypePcontasForm from "../components/pdc/documenttypespcontas/Form"

import FormScreenHelpConfigList from "../components/pdc/formscreenhelpconfigs/List.js"
import FormScreenHelpConfigForm from "../components/pdc/formscreenhelpconfigs/Form.js"

// NEW PORTAL
import EntityProjects from "../../application/components/pdc/portal/EntityProjects/EntityProjects";
import LayoutEntityProjects from "../../application/components/pdc/portal/EntityProjects/Layout.js";

import SalaryEqualitiesList from "../components/pdc/salaryequalities/List"
import SalaryEqualitiesForm from "../components/pdc/salaryequalities/Form"

import EmendationAuthorsList from "../components/pdc/emendationauthors/List"
import EmendationAuthorsForm from "../components/pdc/emendationauthors/Form"

import EmendationGrantorsList from "../components/pdc/emendationgrantors/List"
import EmendationGrantorsForm from "../components/pdc/emendationgrantors/Form"

import EmendationModalitiesList from "../components/pdc/emendationmodalities/List"
import EmendationModalitiesForm from "../components/pdc/emendationmodalities/Form"

import EmendationSituationsList from "../components/pdc/emendationsituations/List"
import EmendationSituationsForm from "../components/pdc/emendationsituations/Form"

import EmendationTypesList from "../components/pdc/emendationtypes/List"
import EmendationTypesForm from "../components/pdc/emendationtypes/Form"

import EmendationsList from "../components/pdc/emendations/List"
import EmendationsForm from "../components/pdc/emendations/Form"
import ReceiveblesList from "../components/pdc/receivebles/List"
import ReceiveblesForm from "../components/pdc/receivebles/Form"

import AllManagersList from "../components/pdc/allmanagers/List"

import AgencyList from "../components/pdc/agencies/List"
import AgencyForm from "../components/pdc/agencies/Form"

import PropertyTypeList from "../components/pdc/propertytypes/List"
import PropertyTypeForm from "../components/pdc/propertytypes/Form"

import PropertyTermList from "../components/pdc/propertyterms/List"
import PropertyTermForm from "../components/pdc/propertyterms/Form"

import PropertyList from "../components/pdc/properties/List"
import PropertyForm from "../components/pdc/properties/Form"

import FederalRevenueImport from "../components/pdc/federalrevenue/FederalRevenueImport"

import CboOccupationList from "../components/pdc/cbooccupations/List"
import CboOccupationForm from "../components/pdc/cbooccupations/Form"

import CboSynonymousList from "../components/pdc/cbosynonyms/List"

import CboSynonymousDescriptionList from "../components/pdc/cbosynonymousdescriptions/List"
import CboSynonymousDescriptionForm from "../components/pdc/cbosynonymousdescriptions/Form"

import CboSynonymousRolesList from "../components/pdc/cbosynonymsrole/List"
import CboSynonymousRolesForm from "../components/pdc/cbosynonymsrole/Form"

import QualificationsList from "../components/pdc/qualifications/List"
import QualificationsForm from "../components/pdc/qualifications/Form"

import UfPortalList from "../components/pdc/ufportal/List"
import UfPortalForm from "../components/pdc/ufportal/Form"

import PspAreaRoleList from "../components/psp/arearoles/List"
import PspAreaRoleForm from "../components/psp/arearoles/Form"

import PspRoleList from "../components/psp/roles/List"
import PspRoleForm from "../components/psp/roles/Form"

import PspDocumentTypeList from "../components/psp/documenttypes/List"
import PspDocumentTypeForm from "../components/psp/documenttypes/Form"

import PspSelectionProcessList from "../components/psp/selectionprocesses/List"
import PspSelectionProcessForm from "../components/psp/selectionprocesses/Form"

import PspSelectionProcessVacancyList from "../components/psp/selectionprocesses/vacancies/List"
import PspSelectionProcessVacancyForm from "../components/psp/selectionprocesses/vacancies/Form"
import PspVacancyCandidateList from "../components/psp/selectionprocesses/vacancies/candidates/List"
import PspVacancyCandidateForm from "../components/psp/selectionprocesses/vacancies/candidates/Form"

import PspPortalLayout from "../components/psp/candidatePortal/components/PortalLayout"
import PspPrivateRoute from "../components/psp/candidatePortal/components/PrivateRoute"
import PspJobList from "../components/psp/candidatePortal/pages/JobList"
import PspJobDetail from "../components/psp/candidatePortal/pages/JobDetail"
import PspLogin from "../components/psp/candidatePortal/pages/Login"
import PspRegister from "../components/psp/candidatePortal/pages/Register"
import PspVerifyEmail from "../components/psp/candidatePortal/pages/VerifyEmail"
import PspForgotPassword from "../components/psp/candidatePortal/pages/ForgotPassword"
import PspResetPassword from "../components/psp/candidatePortal/pages/ResetPassword"
import PspProfile from "../components/psp/candidatePortal/pages/Profile"
import PspHome from "../components/psp/candidatePortal/pages/Home"

function ApplicationRoutes() {
  return (
    <Routes>
      <Route exact path="companies/add" element={<RestrictedArea content={<CompanyForm />} />} />
      <Route exact path="companies/edit/:id" element={<RestrictedArea content={<CompanyEdit />} />} />
      <Route exact path="companies/view/:id" element={<RestrictedArea content={<CompanyEdit />} />} />
      <Route exact path="companies/list" element={<RestrictedArea content={<CompanyList />} />} />

      <Route exact path="businessmanagers/add" element={<RestrictedArea content={<BusinessManagerForm />} />} />
      <Route exact path="businessmanagers/edit/:id" element={<RestrictedArea content={<BusinessManagerEdit />} />} />
      <Route exact path="businessmanagers/view/:id" element={<RestrictedArea content={<BusinessManagerEdit />} />} />
      <Route exact path="businessmanagers/list" element={<RestrictedArea content={<BusinessManagerList />} />} />

      <Route exact path="entities/add" element={<RestrictedArea content={<EntityForm />} />} />
      <Route exact path="entities/edit/:id" element={<RestrictedArea content={<EntityEdit />} />} />
      <Route exact path="entities/view/:id" element={<RestrictedArea content={<EntityEdit />} />} />
      <Route exact path="entities/list" element={<RestrictedArea content={<EntityList />} />} />

      <Route exact path="entitymanagers/add" element={<RestrictedArea content={<EntityManagerForm />} />} />
      <Route exact path="entitymanagers/edit/:id" element={<RestrictedArea content={<EntityManagerEdit />} />} />
      <Route exact path="entitymanagers/view/:id" element={<RestrictedArea content={<EntityManagerEdit />} />} />
      <Route exact path="entitymanagers/list" element={<RestrictedArea content={<EntityManagerList />} />} />

      <Route exact path="clients/add" element={<RestrictedArea content={<ClientForm />} />} />
      <Route exact path="clients/edit/:id" element={<RestrictedArea content={<ClientForm />} />} />
      <Route exact path="clients/view/:id" element={<RestrictedArea content={<ClientForm />} />} />
      <Route exact path="clients/list" element={<RestrictedArea content={<ClientList />} />} />

      <Route exact path="principals/add" element={<RestrictedArea content={<PrincipalForm />} />} />
      <Route exact path="principals/edit/:id" element={<RestrictedArea content={<PrincipalForm />} />} />
      <Route exact path="principals/view/:id" element={<RestrictedArea content={<PrincipalForm />} />} />
      <Route exact path="principals/list" element={<RestrictedArea content={<PrincipalList />} />} />

      <Route exact path="roles/add" element={<RestrictedArea content={<RoleForm />} />} />
      <Route exact path="roles/edit/:id" element={<RestrictedArea content={<RoleForm />} />} />
      <Route exact path="roles/view/:id" element={<RestrictedArea content={<RoleForm />} />} />
      <Route exact path="roles/list" element={<RestrictedArea content={<RoleList />} />} />

      <Route exact path="professions/add" element={<RestrictedArea content={<ProfessionForm />} />} />
      <Route exact path="professions/edit/:id" element={<RestrictedArea content={<ProfessionForm />} />} />
      <Route exact path="professions/view/:id" element={<RestrictedArea content={<ProfessionForm />} />} />
      <Route exact path="professions/list" element={<RestrictedArea content={<ProfessionList />} />} />

      <Route exact path="projects/add" element={<RestrictedArea content={<ProjectForm />} />} />
      <Route exact path="projects/edit/:id" element={<RestrictedArea content={<ProjectEdit />} />} />
      <Route exact path="projects/view/:id" element={<RestrictedArea content={<ProjectEdit />} />} />
      <Route exact path="projects/list" element={<RestrictedArea content={<ProjectList />} />} />

      <Route exact path="projectmodalities/add" element={<RestrictedArea content={<ProjectModalityForm />} />} />
      <Route exact path="projectmodalities/edit/:id" element={<RestrictedArea content={<ProjectModalityForm />} />} />
      <Route exact path="projectmodalities/view/:id" element={<RestrictedArea content={<ProjectModalityForm />} />} />
      <Route exact path="projectmodalities/list" element={<RestrictedArea content={<ProjectModalityList />} />} />

      <Route exact path="documentationcategories/add" element={<RestrictedArea content={<DocumentationCategoryForm />} />} />
      <Route exact path="documentationcategories/edit/:id" element={<RestrictedArea content={<DocumentationCategoryForm />} />} />
      <Route exact path="documentationcategories/view/:id" element={<RestrictedArea content={<DocumentationCategoryForm />} />} />
      <Route exact path="documentationcategories/list" element={<RestrictedArea content={<DocumentationCategoryList />} />} />

      <Route exact path="documenttypes/add" element={<RestrictedArea content={<DocumentTypeForm />} />} />
      <Route exact path="documenttypes/edit/:id" element={<RestrictedArea content={<DocumentTypeForm />} />} />
      <Route exact path="documenttypes/view/:id" element={<RestrictedArea content={<DocumentTypeForm />} />} />
      <Route exact path="documenttypes/list" element={<RestrictedArea content={<DocumentTypeList />} />} />

      <Route exact path="announcementcategories/add" element={<RestrictedArea content={<AnnouncementCategoryForm />} />} />
      <Route exact path="announcementcategories/edit/:id" element={<RestrictedArea content={<AnnouncementCategoryForm />} />} />
      <Route exact path="announcementcategories/view/:id" element={<RestrictedArea content={<AnnouncementCategoryForm />} />} />
      <Route exact path="announcementcategories/list" element={<RestrictedArea content={<AnnouncementCategoryList />} />} />

      <Route exact path="demonstrativetypes/add" element={<RestrictedArea content={<DemonstrativeTypeForm />} />} />
      <Route exact path="demonstrativetypes/edit/:id" element={<RestrictedArea content={<DemonstrativeTypeForm />} />} />
      <Route exact path="demonstrativetypes/view/:id" element={<RestrictedArea content={<DemonstrativeTypeForm />} />} />
      <Route exact path="demonstrativetypes/list" element={<RestrictedArea content={<DemonstrativeTypeList />} />} />

      <Route exact path="adjusttypes/add" element={<RestrictedArea content={<AdjustTypeForm />} />} />
      <Route exact path="adjusttypes/edit/:id" element={<RestrictedArea content={<AdjustTypeForm />} />} />
      <Route exact path="adjusttypes/view/:id" element={<RestrictedArea content={<AdjustTypeForm />} />} />
      <Route exact path="adjusttypes/list" element={<RestrictedArea content={<AdjustTypeList />} />} />

      <Route exact path="documentations/add" element={<RestrictedArea content={<DocumentationForm />} />} />
      <Route exact path="documentations/edit/:id" element={<RestrictedArea content={<DocumentationForm />} />} />
      <Route exact path="documentations/view/:id" element={<RestrictedArea content={<DocumentationForm />} />} />
      <Route exact path="documentations/list" element={<RestrictedArea content={<DocumentationList />} />} />

      <Route exact path="contractualizations/add" element={<RestrictedArea content={<ContractualizationForm />} />} />
      <Route exact path="contractualizations/edit/:id" element={<RestrictedArea content={<ContractualizationForm />} />} />
      <Route exact path="contractualizations/view/:id" element={<RestrictedArea content={<ContractualizationForm />} />} />
      <Route exact path="contractualizations/list" element={<RestrictedArea content={<ContractualizationList />} />} />

      {/* Acompanhamento de Arquivos */}
      <Route exact path="filemonitorings/list" element={<RestrictedArea content={<FileMonitoringList />} />} />

      <Route exact path="announcements/add" element={<RestrictedArea content={<AnnouncementForm />} />} />
      <Route exact path="announcements/edit/:id" element={<RestrictedArea content={<AnnouncementForm />} />} />
      <Route exact path="announcements/view/:id" element={<RestrictedArea content={<AnnouncementForm />} />} />
      <Route exact path="announcements/list" element={<RestrictedArea content={<AnnouncementList />} />} />

      <Route exact path="demonstratives/add" element={<RestrictedArea content={<DemonstrativeForm />} />} />
      <Route exact path="demonstratives/edit/:id" element={<RestrictedArea content={<DemonstrativeForm />} />} />
      <Route exact path="demonstratives/view/:id" element={<RestrictedArea content={<DemonstrativeForm />} />} />
      <Route exact path="demonstratives/list" element={<RestrictedArea content={<DemonstrativeList />} />} />

      <Route exact path="organizationalcharts/add" element={<RestrictedArea content={<OrganizationalChartForm />} />} />
      <Route exact path="organizationalcharts/edit/:id" element={<RestrictedArea content={<OrganizationalChartForm />} />} />
      <Route exact path="organizationalcharts/view/:id" element={<RestrictedArea content={<OrganizationalChartForm />} />} />
      <Route exact path="organizationalcharts/list" element={<RestrictedArea content={<OrganizationalChartList />} />} />

      <Route exact path="projectmanagers/add" element={<RestrictedArea content={<ProjectManagerForm />} />} />
      <Route exact path="projectmanagers/edit/:id" element={<RestrictedArea content={<ProjectManagerEdit />} />} />
      <Route exact path="projectmanagers/view/:id" element={<RestrictedArea content={<ProjectManagerEdit />} />} />
      <Route exact path="projectmanagers/list" element={<RestrictedArea content={<ProjectManagerList />} />} />

      <Route exact path="bimanagers/add" element={<RestrictedArea content={<BiManagerForm />} />} />
      <Route exact path="bimanagers/edit/:id" element={<RestrictedArea content={<BiManagerEdit />} />} />
      <Route exact path="bimanagers/view/:id" element={<RestrictedArea content={<BiManagerEdit />} />} />
      <Route exact path="bimanagers/list" element={<RestrictedArea content={<BiManagerList />} />} />

      <Route exact path="physicfinances/add" element={<RestrictedArea content={<PhysicFinanceForm />} />} />
      <Route exact path="physicfinances/edit/:id" element={<RestrictedArea content={<PhysicFinanceForm />} />} />
      <Route exact path="physicfinances/view/:id" element={<RestrictedArea content={<PhysicFinanceForm />} />} />
      <Route exact path="physicfinances/list" element={<RestrictedArea content={<PhysicFinanceList />} />} />

      <Route exact path="balances/add" element={<RestrictedArea content={<BalanceForm />} />} />
      <Route exact path="balances/edit/:id" element={<RestrictedArea content={<BalanceForm />} />} />
      <Route exact path="balances/view/:id" element={<RestrictedArea content={<BalanceForm />} />} />
      <Route exact path="balances/list" element={<RestrictedArea content={<BalanceList />} />} />

      <Route exact path="reports/add" element={<RestrictedArea content={<ReportForm />} />} />
      <Route exact path="reports/edit/:id" element={<RestrictedArea content={<ReportForm />} />} />
      <Route exact path="reports/view/:id" element={<RestrictedArea content={<ReportForm />} />} />
      <Route exact path="reports/list" element={<RestrictedArea content={<ReportList />} />} />

      <Route exact path="medicalscales/add" element={<RestrictedArea content={<MedicalScaleForm />} />} />
      <Route exact path="medicalscales/edit/:id" element={<RestrictedArea content={<MedicalScaleForm />} />} />
      <Route exact path="medicalscales/view/:id" element={<RestrictedArea content={<MedicalScaleForm />} />} />
      <Route exact path="medicalscales/list" element={<RestrictedArea content={<MedicalScaleList />} />} />

      <Route exact path="portal/:friendly_url/:page" element={<PortalHome />} />
      <Route exact path="portal/entity/:friendly_url" element={<PortalEntity />} />

      <Route exact path="bankinghistories/add" element={<RestrictedArea content={<BankingHistoryForm />} />} />
      <Route exact path="bankinghistories/list" element={<RestrictedArea content={<BankingHistoryList />} />} />
      <Route exact path="bankinghistories/competencies" element={<RestrictedArea content={<CompetencyBankingHistoryList />} />} />
      <Route exact path="bankinghistories/files" element={<RestrictedArea content={<FileBankingHistoryList />} />} />

      <Route exact path="entityemployees/add" element={<RestrictedArea content={<EntityEmployeeForm />} />} />
      <Route exact path="entityemployees/list/:pdc_entity_id" element={<RestrictedArea content={<EntityEmployeeList />} />} />
      <Route exact path="entityemployees/files" element={<RestrictedArea content={<FileEntityEmployeeList />} />} />
      <Route exact path="entityemployees/entities" element={<RestrictedArea content={<EntitiesEntityEmployeeList />} />} />

      <Route exact path="fileemployeepayments/add" element={<RestrictedArea content={<FileEmployeePaymentForm />} />} />
      <Route exact path="fileemployeepayments/list" element={<RestrictedArea content={<FileEmployeePaymentList />} />} />
      <Route exact path="fileemployeepayments/listpayments/:id" element={<RestrictedArea content={<FileEmployeePaymentPaymentsList />} />} />

      <Route exact path="processtypes/add" element={<RestrictedArea content={<ProcessTypeForm />} />} />
      <Route exact path="processtypes/edit/:id" element={<RestrictedArea content={<ProcessTypeForm />} />} />
      <Route exact path="processtypes/view/:id" element={<RestrictedArea content={<ProcessTypeForm />} />} />
      <Route exact path="processtypes/list" element={<RestrictedArea content={<ProcessTypeList />} />} />

      <Route exact path="processes/add" element={<RestrictedArea content={<ProcessForm />} />} />
      <Route exact path="processes/edit/:id" element={<RestrictedArea content={<ProcessForm />} />} />
      <Route exact path="processes/view/:id" element={<RestrictedArea content={<ProcessForm />} />} />
      <Route exact path="processes/list" element={<RestrictedArea content={<ProcessList />} />} />

      <Route exact path="editaldocumenttypes/add" element={<RestrictedArea content={<EditalDocumentTypeForm />} />} />
      <Route exact path="editaldocumenttypes/edit/:id" element={<RestrictedArea content={<EditalDocumentTypeForm />} />} />
      <Route exact path="editaldocumenttypes/view/:id" element={<RestrictedArea content={<EditalDocumentTypeForm />} />} />
      <Route exact path="editaldocumenttypes/list" element={<RestrictedArea content={<EditalDocumentTypeList />} />} />

      <Route exact path="editals/add" element={<RestrictedArea content={<EditalForm />} />} />
      <Route exact path="editals/edit/:id" element={<RestrictedArea content={<EditalForm />} />} />
      <Route exact path="editals/view/:id" element={<RestrictedArea content={<EditalForm />} />} />
      <Route exact path="editals/list" element={<RestrictedArea content={<EditalList />} />} />

      <Route exact path="contractstatuses/add" element={<RestrictedArea content={<ContractStatusForm />} />} />
      <Route exact path="contractstatuses/edit/:id" element={<RestrictedArea content={<ContractStatusForm />} />} />
      <Route exact path="contractstatuses/view/:id" element={<RestrictedArea content={<ContractStatusForm />} />} />
      <Route exact path="contractstatuses/list" element={<RestrictedArea content={<ContractStatusList />} />} />

      <Route exact path="contracttypes/add" element={<RestrictedArea content={<ContractTypeForm />} />} />
      <Route exact path="contracttypes/edit/:id" element={<RestrictedArea content={<ContractTypeForm />} />} />
      <Route exact path="contracttypes/view/:id" element={<RestrictedArea content={<ContractTypeForm />} />} />
      <Route exact path="contracttypes/list" element={<RestrictedArea content={<ContractTypeList />} />} />

      <Route exact path="suppliers/add" element={<RestrictedArea content={<SupplierForm />} />} />
      <Route exact path="suppliers/edit/:id" element={<RestrictedArea content={<SupplierForm />} />} />
      <Route exact path="suppliers/view/:id" element={<RestrictedArea content={<SupplierForm />} />} />
      <Route exact path="suppliers/list" element={<RestrictedArea content={<SupplierList />} />} />

      <Route exact path="contracts/add" element={<RestrictedArea content={<ContractForm />} />} />
      <Route exact path="contracts/edit/:id" element={<RestrictedArea content={<ContractForm />} />} />
      <Route exact path="contracts/view/:id" element={<RestrictedArea content={<ContractForm />} />} />
      <Route exact path="contracts/list" element={<RestrictedArea content={<ContractList />} />} />

      <Route exact path="movementtypes/add" element={<RestrictedArea content={<MovementTypeForm />} />} />
      <Route exact path="movementtypes/edit/:id" element={<RestrictedArea content={<MovementTypeForm />} />} />
      <Route exact path="movementtypes/view/:id" element={<RestrictedArea content={<MovementTypeForm />} />} />
      <Route exact path="movementtypes/list" element={<RestrictedArea content={<MovementTypeList />} />} />

      <Route exact path="movements/add" element={<RestrictedArea content={<MovementForm />} />} />
      <Route exact path="movements/edit/:id" element={<RestrictedArea content={<MovementForm />} />} />
      <Route exact path="movements/view/:id" element={<RestrictedArea content={<MovementForm />} />} />
      <Route exact path="movements/list" element={<RestrictedArea content={<MovementList />} />} />

      <Route exact path="medicalscaletypes/add" element={<RestrictedArea content={<MedicalScaleTypeForm />} />} />
      <Route exact path="medicalscaletypes/edit/:id" element={<RestrictedArea content={<MedicalScaleTypeForm />} />} />
      <Route exact path="medicalscaletypes/view/:id" element={<RestrictedArea content={<MedicalScaleTypeForm />} />} />
      <Route exact path="medicalscaletypes/list" element={<RestrictedArea content={<MedicalScaleTypeList />} />} />

      <Route exact path="entityspecialties/add" element={<RestrictedArea content={<EntitySpecialtyForm />} />} />
      <Route exact path="entityspecialties/edit/:id" element={<RestrictedArea content={<EntitySpecialtyForm />} />} />
      <Route exact path="entityspecialties/view/:id" element={<RestrictedArea content={<EntitySpecialtyForm />} />} />
      <Route exact path="entityspecialties/list" element={<RestrictedArea content={<EntitySpecialtyList />} />} />
      <Route exact path="rolenames/add" element={<RestrictedArea content={<RoleNameForm />} />} />
      <Route exact path="rolenames/edit/:id" element={<RestrictedArea content={<RoleNameForm />} />} />
      <Route exact path="rolenames/view/:id" element={<RestrictedArea content={<RoleNameForm />} />} />
      <Route exact path="rolenames/list" element={<RestrictedArea content={<RoleNameList />} />} />
      <Route exact path="sectors/add" element={<RestrictedArea content={<SectorForm />} />} />
      <Route exact path="sectors/edit/:id" element={<RestrictedArea content={<SectorForm />} />} />
      <Route exact path="sectors/view/:id" element={<RestrictedArea content={<SectorForm />} />} />
      <Route exact path="sectors/list" element={<RestrictedArea content={<SectorList />} />} />
      <Route exact path="educationlevels/add" element={<RestrictedArea content={<EducationLevelForm />} />} />
      <Route exact path="educationlevels/edit/:id" element={<RestrictedArea content={<EducationLevelForm />} />} />
      <Route exact path="educationlevels/view/:id" element={<RestrictedArea content={<EducationLevelForm />} />} />
      <Route exact path="educationlevels/list" element={<RestrictedArea content={<EducationLevelList />} />} />
      <Route exact path="leadershippositions/add" element={<RestrictedArea content={<LeadershipPositionForm />} />} />
      <Route exact path="leadershippositions/edit/:id" element={<RestrictedArea content={<LeadershipPositionForm />} />} />
      <Route exact path="leadershippositions/view/:id" element={<RestrictedArea content={<LeadershipPositionForm />} />} />
      <Route exact path="leadershippositions/list" element={<RestrictedArea content={<LeadershipPositionList />} />} />
      <Route exact path="competencycategories/add" element={<RestrictedArea content={<CompetencyCategoryForm />} />} />
      <Route exact path="competencycategories/edit/:id" element={<RestrictedArea content={<CompetencyCategoryForm />} />} />
      <Route exact path="competencycategories/view/:id" element={<RestrictedArea content={<CompetencyCategoryForm />} />} />
      <Route exact path="competencycategories/list" element={<RestrictedArea content={<CompetencyCategoryList />} />} />
      <Route exact path="technicalcompetencies/add" element={<RestrictedArea content={<TechnicalCompetencyForm />} />} />
      <Route exact path="technicalcompetencies/edit/:id" element={<RestrictedArea content={<TechnicalCompetencyForm />} />} />
      <Route exact path="technicalcompetencies/view/:id" element={<RestrictedArea content={<TechnicalCompetencyForm />} />} />
      <Route exact path="technicalcompetencies/list" element={<RestrictedArea content={<TechnicalCompetencyList />} />} />
      <Route exact path="behavioralcompetencies/add" element={<RestrictedArea content={<BehavioralCompetencyForm />} />} />
      <Route exact path="behavioralcompetencies/edit/:id" element={<RestrictedArea content={<BehavioralCompetencyForm />} />} />
      <Route exact path="behavioralcompetencies/view/:id" element={<RestrictedArea content={<BehavioralCompetencyForm />} />} />
      <Route exact path="behavioralcompetencies/list" element={<RestrictedArea content={<BehavioralCompetencyList />} />} />
      <Route exact path="roleclasses/add" element={<RestrictedArea content={<RoleClassForm />} />} />
      <Route exact path="roleclasses/edit/:id" element={<RestrictedArea content={<RoleClassForm />} />} />
      <Route exact path="roleclasses/view/:id" element={<RestrictedArea content={<RoleClassForm />} />} />
      <Route exact path="roleclasses/list" element={<RestrictedArea content={<RoleClassList />} />} />
      <Route exact path="roleclassifications/add" element={<RestrictedArea content={<RoleClassificationForm />} />} />
      <Route exact path="roleclassifications/edit/:id" element={<RestrictedArea content={<RoleClassificationForm />} />} />
      <Route exact path="roleclassifications/view/:id" element={<RestrictedArea content={<RoleClassificationForm />} />} />
      <Route exact path="roleclassifications/list" element={<RestrictedArea content={<RoleClassificationList />} />} />
      <Route exact path="trainings/add" element={<RestrictedArea content={<TrainingForm />} />} />
      <Route exact path="trainings/edit/:id" element={<RestrictedArea content={<TrainingForm />} />} />
      <Route exact path="trainings/view/:id" element={<RestrictedArea content={<TrainingForm />} />} />
      <Route exact path="trainings/list" element={<RestrictedArea content={<TrainingList />} />} />
      <Route exact path="systemaccesses/add" element={<RestrictedArea content={<SystemAccessForm />} />} />
      <Route exact path="systemaccesses/edit/:id" element={<RestrictedArea content={<SystemAccessForm />} />} />
      <Route exact path="systemaccesses/view/:id" element={<RestrictedArea content={<SystemAccessForm />} />} />
      <Route exact path="systemaccesses/list" element={<RestrictedArea content={<SystemAccessList />} />} />
      <Route exact path="positions/add" element={<RestrictedArea content={<PositionForm />} />} />
      <Route exact path="positions/edit/:id" element={<RestrictedArea content={<PositionForm />} />} />
      <Route exact path="positions/view/:id" element={<RestrictedArea content={<PositionForm />} />} />
      <Route exact path="positions/list" element={<RestrictedArea content={<PositionList />} />} />

      <Route exact path="projectdepartments/add" element={<RestrictedArea content={<ProjectDepartmentForm />} />} />
      <Route exact path="projectdepartments/edit/:id" element={<RestrictedArea content={<ProjectDepartmentForm />} />} />
      <Route exact path="projectdepartments/view/:id" element={<RestrictedArea content={<ProjectDepartmentForm />} />} />
      <Route exact path="projectdepartments/list" element={<RestrictedArea content={<ProjectDepartmentList />} />} />

      <Route exact path="projectindicators/add" element={<RestrictedArea content={<ProjectIndicatorsForm />} />} />
      <Route exact path="projectindicators/edit/:id" element={<RestrictedArea content={<ProjectIndicatorsForm />} />} />
      <Route exact path="projectindicators/view/:id" element={<RestrictedArea content={<ProjectIndicatorsForm />} />} />
      <Route exact path="projectindicators/list" element={<RestrictedArea content={<ProjectIndicatorsList />} />} />

      <Route exact path="fileaccountabilities/add" element={<RestrictedArea content={<FileAccountabilitiesForm />} />} />
      <Route exact path="fileaccountabilities/view/:id" element={<RestrictedArea content={<FileAccountabilitiesForm />} />} />
      <Route exact path="fileaccountabilities/list" element={<RestrictedArea content={<FileAccountabilitiesList />} />} />

      <Route exact path="accountingprojects/add" element={<RestrictedArea content={<AccountingProjectsForm />} />} />
      <Route exact path="accountingprojects/view/:id" element={<RestrictedArea content={<AccountingProjectsForm />} />} />
      <Route exact path="accountingprojects/edit/:id" element={<RestrictedArea content={<AccountingProjectsForm />} />} />
      <Route exact path="accountingprojects/list" element={<RestrictedArea content={<AccountingProjectsList />} />} />

      <Route exact path="accountingclients/view/:id" element={<RestrictedArea content={<AccountingClientsForm />} />} />
      <Route exact path="accountingclients/edit/:id" element={<RestrictedArea content={<AccountingClientsForm />} />} />
      <Route exact path="accountingclients/list" element={<RestrictedArea content={<AccountingClientsList />} />} />

      <Route exact path="pcontasaccountspayable/view/:id" element={<RestrictedArea content={<PcontasAccountsPayableForm />} />} />
      <Route exact path="pcontasaccountspayable/list" element={<RestrictedArea content={<PcontasAccountsPayableList />} />} />

      <Route exact path="pcontasaccountsrevenues/view/:id" element={<RestrictedArea content={<PcontasAccountsRevenueForm />} />} />
      <Route exact path="pcontasaccountsrevenues/list" element={<RestrictedArea content={<PcontasAccountsRevenueList />} />} />

      <Route exact path="portal/entity-projects/:friendly_url" element={<LayoutEntityProjects content={<EntityProjects />} />} />

      <Route exact path="projectdocumentations/add" element={<RestrictedArea content={<ProjectDocumentationForm />} />} />
      <Route exact path="projectdocumentations/edit/:id" element={<RestrictedArea content={<ProjectDocumentationForm />} />} />
      <Route exact path="projectdocumentations/view/:id" element={<RestrictedArea content={<ProjectDocumentationForm />} />} />
      <Route exact path="projectdocumentations/list" element={<RestrictedArea content={<ProjectDocumentationList />} />} />

      <Route exact path="servicecharters/add" element={<RestrictedArea content={<ServiceCharterForm />} />} />
      <Route exact path="servicecharters/edit/:id" element={<RestrictedArea content={<ServiceCharterForm />} />} />
      <Route exact path="servicecharters/view/:id" element={<RestrictedArea content={<ServiceCharterForm />} />} />
      <Route exact path="servicecharters/list" element={<RestrictedArea content={<ServiceCharterList />} />} />

      <Route exact path="bankaccounts/add" element={<RestrictedArea content={<BankAccountForm />} />} />
      <Route exact path="bankaccounts/edit/:id" element={<RestrictedArea content={<BankAccountForm />} />} />
      <Route exact path="bankaccounts/view/:id" element={<RestrictedArea content={<BankAccountForm />} />} />
      <Route exact path="bankaccounts/list" element={<RestrictedArea content={<BankAccountList />} />} />

      <Route exact path="selectionprocesses/add" element={<RestrictedArea content={<SelectionProcessForm />} />} />
      <Route exact path="selectionprocesses/edit/:id" element={<RestrictedArea content={<SelectionProcessForm />} />} />
      <Route exact path="selectionprocesses/view/:id" element={<RestrictedArea content={<SelectionProcessForm />} />} />
      <Route exact path="selectionprocesses/list" element={<RestrictedArea content={<SelectionProcessList />} />} />

      <Route exact path="banks/add" element={<RestrictedArea content={<BankForm />} />} />
      <Route exact path="banks/edit/:id" element={<RestrictedArea content={<BankForm />} />} />
      <Route exact path="banks/view/:id" element={<RestrictedArea content={<BankForm />} />} />
      <Route exact path="banks/list" element={<RestrictedArea content={<BankList />} />} />


      <Route exact path="bankagencies/add" element={<RestrictedArea content={<BankAgencyForm />} />} />
      <Route exact path="bankagencies/edit/:id" element={<RestrictedArea content={<BankAgencyForm />} />} />
      <Route exact path="bankagencies/view/:id" element={<RestrictedArea content={<BankAgencyForm />} />} />
      <Route exact path="bankagencies/list" element={<RestrictedArea content={<BankAgencyList />} />} />

      <Route exact path="legaltypes/add" element={<RestrictedArea content={<LegalTypesForm />} />} />
      <Route exact path="legaltypes/edit/:id" element={<RestrictedArea content={<LegalTypesForm />} />} />
      <Route exact path="legaltypes/view/:id" element={<RestrictedArea content={<LegalTypesForm />} />} />
      <Route exact path="legaltypes/list" element={<RestrictedArea content={<LegalTypesList />} />} />

      <Route exact path="paymentmethods/add" element={<RestrictedArea content={<PaymentMethodsForm />} />} />
      <Route exact path="paymentmethods/edit/:id" element={<RestrictedArea content={<PaymentMethodsForm />} />} />
      <Route exact path="paymentmethods/view/:id" element={<RestrictedArea content={<PaymentMethodsForm />} />} />
      <Route exact path="paymentmethods/list" element={<RestrictedArea content={<PaymentMethodsList />} />} />

      <Route exact path="taxcategories/add" element={<RestrictedArea content={<TaxCategoriesForm />} />} />
      <Route exact path="taxcategories/edit/:id" element={<RestrictedArea content={<TaxCategoriesForm />} />} />
      <Route exact path="taxcategories/view/:id" element={<RestrictedArea content={<TaxCategoriesForm />} />} />
      <Route exact path="taxcategories/list" element={<RestrictedArea content={<TaxCategoriesList />} />} />

      <Route exact path="resourcesourcesclassifications/add" element={<RestrictedArea content={<ResourceSourcesClassificationsForm />} />} />
      <Route exact path="resourcesourcesclassifications/edit/:id" element={<RestrictedArea content={<ResourceSourcesClassificationsForm />} />} />
      <Route exact path="resourcesourcesclassifications/view/:id" element={<RestrictedArea content={<ResourceSourcesClassificationsForm />} />} />
      <Route exact path="resourcesourcesclassifications/list" element={<RestrictedArea content={<ResourceSourcesClassificationsList />} />} />

      <Route exact path="selectionprocesses/add" element={<RestrictedArea content={<SelectionProcessForm />} />} />
      <Route exact path="selectionprocesses/edit/:id" element={<RestrictedArea content={<SelectionProcessForm />} />} />
      <Route exact path="selectionprocesses/view/:id" element={<RestrictedArea content={<SelectionProcessForm />} />} />
      <Route exact path="selectionprocesses/list" element={<RestrictedArea content={<SelectionProcessList />} />} />
            
      <Route exact path="taxcategories/add" element={<RestrictedArea content={<TaxCategoriesForm />} />} />
      <Route exact path="taxcategories/edit/:id" element={<RestrictedArea content={<TaxCategoriesForm />} />} />
      <Route exact path="taxcategories/view/:id" element={<RestrictedArea content={<TaxCategoriesForm />} />} />
      <Route exact path="taxcategories/list" element={<RestrictedArea content={<TaxCategoriesList />} />} />
      
      <Route exact path="resourcesources/add" element={<RestrictedArea content={<ResourceSourcesForm />} />} />
      <Route exact path="resourcesources/edit/:id" element={<RestrictedArea content={<ResourceSourcesForm />} />} />
      <Route exact path="resourcesources/view/:id" element={<RestrictedArea content={<ResourceSourcesForm />} />} />
      <Route exact path="resourcesources/list" element={<RestrictedArea content={<ResourceSourcesList />} />} />

      <Route exact path="attachmenttypes/add" element={<RestrictedArea content={<AttachmentForm />} />} />
      <Route exact path="attachmenttypes/edit/:id" element={<RestrictedArea content={<AttachmentForm />} />} />
      <Route exact path="attachmenttypes/view/:id" element={<RestrictedArea content={<AttachmentForm />} />} />
      <Route exact path="attachmenttypes/list" element={<RestrictedArea content={<AttachmentList />} />} />
      
      <Route exact path="projectunits/add" element={<RestrictedArea content={<ProjectUnitsForm />} />} />
      <Route exact path="projectunits/edit/:id" element={<RestrictedArea content={<ProjectUnitsForm />} />} />
      <Route exact path="projectunits/view/:id" element={<RestrictedArea content={<ProjectUnitsForm />} />} />
      <Route exact path="projectunits/list" element={<RestrictedArea content={<ProjectUnitsList />} />} />

      <Route exact path="bankaccounttypes/add" element={<RestrictedArea content={<BankAccountTypeForm />} />} />
      <Route exact path="bankaccounttypes/edit/:id" element={<RestrictedArea content={<BankAccountTypeForm />} />} />
      <Route exact path="bankaccounttypes/view/:id" element={<RestrictedArea content={<BankAccountTypeForm />} />} />
      <Route exact path="bankaccounttypes/list" element={<RestrictedArea content={<BankAccountTypeList />} />} />

      <Route exact path="people/add" element={<RestrictedArea content={<PeopleForm />} />} />
      <Route exact path="people/add/:id" element={<RestrictedArea content={<PeopleForm />} />} />
      <Route exact path="people/edit/:id" element={<RestrictedArea content={<PeopleEdit />} />} />
      <Route exact path="people/view/:id" element={<RestrictedArea content={<PeopleEdit />} />} />
      <Route exact path="people/list" element={<RestrictedArea content={<PeopleList />} />} />

      <Route exact path="taxes/add" element={<RestrictedArea content={<TaxesForm />} />} />
      <Route exact path="taxes/edit/:id" element={<RestrictedArea content={<TaxesForm />} />} />
      <Route exact path="taxes/view/:id" element={<RestrictedArea content={<TaxesForm />} />} />
      <Route exact path="taxes/list" element={<RestrictedArea content={<TaxesList />} />} />

      <Route exact path="courtauditorscategories/add" element={<RestrictedArea content={<CourtAuditorsCategoriesForm />} />} />
      <Route exact path="courtauditorscategories/edit/:id" element={<RestrictedArea content={<CourtAuditorsCategoriesForm />} />} />
      <Route exact path="courtauditorscategories/view/:id" element={<RestrictedArea content={<CourtAuditorsCategoriesForm />} />} />
      <Route exact path="courtauditorscategories/list" element={<RestrictedArea content={<CourtAuditorsCategoriesList />} />} />

      <Route exact path="workplancategories/add" element={<RestrictedArea content={<WorkPlanCategoriesForm />} />} />
      <Route exact path="workplancategories/edit/:id" element={<RestrictedArea content={<WorkPlanCategoriesForm />} />} />
      <Route exact path="workplancategories/view/:id" element={<RestrictedArea content={<WorkPlanCategoriesForm />} />} />
      <Route exact path="workplancategories/list" element={<RestrictedArea content={<WorkPlanCategoriesList />} />} />
      
      <Route exact path="workplansubcategories/add" element={<RestrictedArea content={<WorkPlanSubCategoriesForm />} />} />
      <Route exact path="workplansubcategories/edit/:id" element={<RestrictedArea content={<WorkPlanSubCategoriesForm />} />} />
      <Route exact path="workplansubcategories/view/:id" element={<RestrictedArea content={<WorkPlanSubCategoriesForm />} />} />
      <Route exact path="workplansubcategories/list" element={<RestrictedArea content={<WorkPlanSubCategoriesList />} />} />
      
      <Route exact path="fiscalcategories/add" element={<RestrictedArea content={<FiscalCategoriesForm />} />} />
      <Route exact path="fiscalcategories/edit/:id" element={<RestrictedArea content={<FiscalCategoriesForm />} />} />
      <Route exact path="fiscalcategories/view/:id" element={<RestrictedArea content={<FiscalCategoriesForm />} />} />
      <Route exact path="fiscalcategories/list" element={<RestrictedArea content={<FiscalCategoriesList />} />} />

      <Route exact path="documenttypespcontas/add" element={<RestrictedArea content={<DocumentTypePcontasForm />} />} />
      <Route exact path="documenttypespcontas/edit/:id" element={<RestrictedArea content={<DocumentTypePcontasForm />} />} />
      <Route exact path="documenttypespcontas/view/:id" element={<RestrictedArea content={<DocumentTypePcontasForm />} />} />
      <Route exact path="documenttypespcontas/list" element={<RestrictedArea content={<DocumentTypePcontasList />} />} />

      <Route exact path="salaryequalities/add" element={<RestrictedArea content={<SalaryEqualitiesForm />} />} />
      <Route exact path="salaryequalities/edit/:id" element={<RestrictedArea content={<SalaryEqualitiesForm />} />} />
      <Route exact path="salaryequalities/view/:id" element={<RestrictedArea content={<SalaryEqualitiesForm />} />} />
      <Route exact path="salaryequalities/list" element={<RestrictedArea content={<SalaryEqualitiesList />} />} />
    
      <Route exact path="emendationauthors/add" element={<RestrictedArea content={<EmendationAuthorsForm />} />} />
      <Route exact path="emendationauthors/edit/:id" element={<RestrictedArea content={<EmendationAuthorsForm />} />} />
      <Route exact path="emendationauthors/view/:id" element={<RestrictedArea content={<EmendationAuthorsForm />} />} />
      <Route exact path="emendationauthors/list" element={<RestrictedArea content={<EmendationAuthorsList />} />} />
    
      <Route exact path="emendationgrantors/add" element={<RestrictedArea content={<EmendationGrantorsForm />} />} />
      <Route exact path="emendationgrantors/edit/:id" element={<RestrictedArea content={<EmendationGrantorsForm />} />} />
      <Route exact path="emendationgrantors/view/:id" element={<RestrictedArea content={<EmendationGrantorsForm />} />} />
      <Route exact path="emendationgrantors/list" element={<RestrictedArea content={<EmendationGrantorsList />} />} />
    
      <Route exact path="emendationmodalities/add" element={<RestrictedArea content={<EmendationModalitiesForm />} />} />
      <Route exact path="emendationmodalities/edit/:id" element={<RestrictedArea content={<EmendationModalitiesForm />} />} />
      <Route exact path="emendationmodalities/view/:id" element={<RestrictedArea content={<EmendationModalitiesForm />} />} />
      <Route exact path="emendationmodalities/list" element={<RestrictedArea content={<EmendationModalitiesList />} />} />
    
      <Route exact path="emendationsituations/add" element={<RestrictedArea content={<EmendationSituationsForm />} />} />
      <Route exact path="emendationsituations/edit/:id" element={<RestrictedArea content={<EmendationSituationsForm />} />} />
      <Route exact path="emendationsituations/view/:id" element={<RestrictedArea content={<EmendationSituationsForm />} />} />
      <Route exact path="emendationsituations/list" element={<RestrictedArea content={<EmendationSituationsList />} />} />
    
      <Route exact path="emendationtypes/add" element={<RestrictedArea content={<EmendationTypesForm />} />} />
      <Route exact path="emendationtypes/edit/:id" element={<RestrictedArea content={<EmendationTypesForm />} />} />
      <Route exact path="emendationtypes/view/:id" element={<RestrictedArea content={<EmendationTypesForm />} />} />
      <Route exact path="emendationtypes/list" element={<RestrictedArea content={<EmendationTypesList />} />} />
    
      <Route exact path="emendations/add" element={<RestrictedArea content={<EmendationsForm />} />} />
      <Route exact path="emendations/edit/:id" element={<RestrictedArea content={<EmendationsForm />} />} />
      <Route exact path="emendations/view/:id" element={<RestrictedArea content={<EmendationsForm />} />} />
      <Route exact path="emendations/list" element={<RestrictedArea content={<EmendationsList />} />} />


      <Route exact path="receivebles/add" element={<RestrictedArea content={<ReceiveblesForm />} />} />
      <Route exact path="receivebles/edit/:id" element={<RestrictedArea content={<ReceiveblesForm />} />} />
      <Route exact path="receivebles/view/:id" element={<RestrictedArea content={<ReceiveblesForm />} />} />
      <Route exact path="receivebles/list" element={<RestrictedArea content={<ReceiveblesList />} />} />
      
      <Route exact path="allmanagers/list" element={<RestrictedArea content={<AllManagersList />} />} />

      <Route exact path="agencies/add" element={<RestrictedArea content={<AgencyForm />} />} />
      <Route exact path="agencies/edit/:id" element={<RestrictedArea content={<AgencyForm />} />} />
      <Route exact path="agencies/view/:id" element={<RestrictedArea content={<AgencyForm />} />} />
      <Route exact path="agencies/list" element={<RestrictedArea content={<AgencyList />} />} />

      <Route exact path="propertytypes/add" element={<RestrictedArea content={<PropertyTypeForm />} />} />
      <Route exact path="propertytypes/edit/:id" element={<RestrictedArea content={<PropertyTypeForm />} />} />
      <Route exact path="propertytypes/view/:id" element={<RestrictedArea content={<PropertyTypeForm />} />} />
      <Route exact path="propertytypes/list" element={<RestrictedArea content={<PropertyTypeList />} />} />

      <Route exact path="propertyterms/add" element={<RestrictedArea content={<PropertyTermForm />} />} />
      <Route exact path="propertyterms/edit/:id" element={<RestrictedArea content={<PropertyTermForm />} />} />
      <Route exact path="propertyterms/view/:id" element={<RestrictedArea content={<PropertyTermForm />} />} />
      <Route exact path="propertyterms/list" element={<RestrictedArea content={<PropertyTermList />} />} />

      <Route exact path="properties/add" element={<RestrictedArea content={<PropertyForm />} />} />
      <Route exact path="properties/edit/:id" element={<RestrictedArea content={<PropertyForm />} />} />
      <Route exact path="properties/view/:id" element={<RestrictedArea content={<PropertyForm />} />} />
      <Route exact path="properties/list" element={<RestrictedArea content={<PropertyList />} />} />
      
      <Route exact path="federalrevenue/view" element={<RestrictedArea content={<FederalRevenueImport />} />} />
      
      <Route exact path="cbooccupations/add" element={<RestrictedArea content={<CboOccupationForm />} />} />
      <Route exact path="cbooccupations/list" element={<RestrictedArea content={<CboOccupationList />} />} />
      
      <Route exact path="cbosynonyms/list" element={<RestrictedArea content={<CboSynonymousList />} />} />

      <Route exact path="cbosynonymousdescriptions/add" element={<RestrictedArea content={<CboSynonymousDescriptionForm />} />} />
      <Route exact path="cbosynonymousdescriptions/edit/:id" element={<RestrictedArea content={<CboSynonymousDescriptionForm />} />} />
      <Route exact path="cbosynonymousdescriptions/view/:id" element={<RestrictedArea content={<CboSynonymousDescriptionForm />} />} />
      <Route exact path="cbosynonymousdescriptions/list" element={<RestrictedArea content={<CboSynonymousDescriptionList />} />} />
      
      <Route exact path="synonymsroleslink/list" element={<RestrictedArea content={<CboSynonymousRolesList />} />} />
      <Route exact path="synonymsroleslink/add" element={<RestrictedArea content={<CboSynonymousRolesForm />} />} />
      <Route exact path="synonymsroleslink/edit/:id" element={<RestrictedArea content={<CboSynonymousRolesForm />} />} />
      <Route exact path="synonymsroleslink/view/:id" element={<RestrictedArea content={<CboSynonymousRolesForm />} />} />

      <Route exact path="formscreenhelpconfigs/add" element={<RestrictedArea content={<FormScreenHelpConfigForm />} />} />
      <Route exact path="formscreenhelpconfigs/edit/:id" element={<RestrictedArea content={<FormScreenHelpConfigForm />} />} />
      <Route exact path="formscreenhelpconfigs/view/:id" element={<RestrictedArea content={<FormScreenHelpConfigForm />} />} />
      <Route exact path="formscreenhelpconfigs/list" element={<RestrictedArea content={<FormScreenHelpConfigList />} />} />
      
      <Route exact path="qualifications/add" element={<RestrictedArea content={<QualificationsForm />} />} />
      <Route exact path="qualifications/edit/:id" element={<RestrictedArea content={<QualificationsForm />} />} />
      <Route exact path="qualifications/view/:id" element={<RestrictedArea content={<QualificationsForm />} />} />
      <Route exact path="qualifications/list" element={<RestrictedArea content={<QualificationsList />} />} />

      <Route exact path="ufportal/add" element={<RestrictedArea content={<UfPortalForm />} />} />
      <Route exact path="ufportal/edit/:id" element={<RestrictedArea content={<UfPortalForm />} />} />
      <Route exact path="ufportal/view/:id" element={<RestrictedArea content={<UfPortalForm />} />} />
      <Route exact path="ufportal/list" element={<RestrictedArea content={<UfPortalList />} />} />    
  
      <Route exact path="psp-arearoles/add" element={<RestrictedArea content={<PspAreaRoleForm />} />} />
      <Route exact path="psp-arearoles/edit/:id" element={<RestrictedArea content={<PspAreaRoleForm />} />} />
      <Route exact path="psp-arearoles/view/:id" element={<RestrictedArea content={<PspAreaRoleForm />} />} />
      <Route exact path="psp-arearoles/list" element={<RestrictedArea content={<PspAreaRoleList />} />} />

      <Route exact path="psp-roles/add" element={<RestrictedArea content={<PspRoleForm />} />} />
      <Route exact path="psp-roles/edit/:id" element={<RestrictedArea content={<PspRoleForm />} />} />
      <Route exact path="psp-roles/view/:id" element={<RestrictedArea content={<PspRoleForm />} />} />
      <Route exact path="psp-roles/list" element={<RestrictedArea content={<PspRoleList />} />} />

      <Route exact path="psp-documenttypes/add" element={<RestrictedArea content={<PspDocumentTypeForm />} />} />
      <Route exact path="psp-documenttypes/edit/:id" element={<RestrictedArea content={<PspDocumentTypeForm />} />} />
      <Route exact path="psp-documenttypes/view/:id" element={<RestrictedArea content={<PspDocumentTypeForm />} />} />
      <Route exact path="psp-documenttypes/list" element={<RestrictedArea content={<PspDocumentTypeList />} />} />
    
      <Route exact path="psp-selectionprocesses/add" element={<RestrictedArea content={<PspSelectionProcessForm />} />} />
      <Route exact path="psp-selectionprocesses/edit/:id" element={<RestrictedArea content={<PspSelectionProcessForm />} />} />
      <Route exact path="psp-selectionprocesses/view/:id" element={<RestrictedArea content={<PspSelectionProcessForm />} />} />
      <Route exact path="psp-selectionprocesses/list" element={<RestrictedArea content={<PspSelectionProcessList />} />} />

      <Route exact path="psp-selectionprocesses/:selectionProcessId/vacancies/add" element={<RestrictedArea content={<PspSelectionProcessVacancyForm />} />} />
      <Route exact path="psp-selectionprocesses/:selectionProcessId/vacancies/edit/:id" element={<RestrictedArea content={<PspSelectionProcessVacancyForm />} />} />
      <Route exact path="psp-selectionprocesses/:selectionProcessId/vacancies/view/:id" element={<RestrictedArea content={<PspSelectionProcessVacancyForm />} />} />
      <Route exact path="psp-selectionprocesses/:selectionProcessId/vacancies/list" element={<RestrictedArea content={<PspSelectionProcessVacancyList />} />} />

      <Route exact path="psp-selectionprocesses/:selectionProcessId/vacancies/:vacancyId/candidates/list" element={<RestrictedArea content={<PspVacancyCandidateList />} />} />
      <Route exact path="psp-selectionprocesses/:selectionProcessId/vacancies/:vacancyId/candidates/view/:id" element={<RestrictedArea content={<PspVacancyCandidateForm />} />} />

      <Route exact path="psp-selectionprocesses/vacancies/add" element={<RestrictedArea content={<PspSelectionProcessVacancyForm />} />} />
      <Route exact path="psp-selectionprocesses/vacancies/edit/:id" element={<RestrictedArea content={<PspSelectionProcessVacancyForm />} />} />
      <Route exact path="psp-selectionprocesses/vacancies/view/:id" element={<RestrictedArea content={<PspSelectionProcessVacancyForm />} />} />
      <Route exact path="psp-selectionprocesses/vacancies/list" element={<RestrictedArea content={<PspSelectionProcessVacancyList />} />} />
    
      <Route path="processos-seletivos/:friendly_url" element={<PspPortalLayout />}>
        <Route index element={<PspJobList />} />
        <Route path="vagas" element={<PspJobList />} />
        <Route path="vagas/:id" element={<PspJobDetail />} />
        <Route path="login" element={<PspLogin />} />
        <Route path="cadastro" element={<PspRegister />} />
        <Route path="verificar-email" element={<PspVerifyEmail />} />
        <Route path="recuperar-senha" element={<PspForgotPassword />} />
        <Route path="redefinir-senha" element={<PspResetPassword />} />
        <Route path="perfil" element={<PspPrivateRoute><PspProfile /></PspPrivateRoute>} />
        <Route path="home" element={<PspPrivateRoute><PspHome /></PspPrivateRoute>} />
        <Route path="projects" element={<PspPrivateRoute><PspHome /></PspPrivateRoute>} />
      </Route> 
    </Routes >
  );
}


export default ApplicationRoutes;